// firebase.ts - app Firebase de la landing (config web publique).
// Firestore ET App Check sont chargés PARESSEUSEMENT (imports dynamiques) : le
// bundle initial reste léger et aucun script tiers (reCAPTCHA) n'est chargé avant
// qu'une opération data soit réellement nécessaire.
import { initializeApp } from "firebase/app";
import type { Firestore } from "firebase/firestore";
import { firebaseConfigDev, firebaseConfigPublic } from "@hop-resto/shared";

// Sélection du backend au build : `vite build --mode dev` (.env.dev) cible le
// projet hop-resto-dev (Firestore/Functions de dev), sinon la prod.
const isDevBackend = import.meta.env.VITE_FIREBASE_ENV === "dev";

/** App Firebase - exportée pour Analytics (chargé après consentement). */
export const app = initializeApp(isDevBackend ? firebaseConfigDev : firebaseConfigPublic);

if (isDevBackend) {
  console.info("[landing] backend Firebase : hop-resto-dev (mode dev)");
}

let appCheckDone = false;
async function ensureAppCheck(): Promise<void> {
  if (appCheckDone) return;
  appCheckDone = true;
  const key = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  if (!key) return; // pas de clé → pas d'App Check (dev / avant activation)
  const { initializeAppCheck, ReCaptchaV3Provider } = await import("firebase/app-check");
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(key),
    isTokenAutoRefreshEnabled: true,
  });
}

let dbPromise: Promise<Firestore> | null = null;

/** Firestore, importé dynamiquement une seule fois (mémoïsé). */
export function getDb(): Promise<Firestore> {
  if (!dbPromise) {
    dbPromise = (async () => {
      await ensureAppCheck();
      const m = await import("firebase/firestore");
      const db = m.getFirestore(app);
      // Émulateurs - opt-in via VITE_USE_EMULATORS=true.
      if (import.meta.env.VITE_USE_EMULATORS === "true") {
        m.connectFirestoreEmulator(db, "127.0.0.1", 8080);
      }
      return db;
    })();
  }
  return dbPromise;
}
